var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footer-box"},[_c('p',{attrs:{"id":"footer-text"}},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":_vm.platformProviderURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.platform))]),_vm._v(". All rights reserved. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }